import React, { useState, useCallback } from "react";
import { SearchParameters } from "../model/SearchParameters";
import useMediaQuery from "./useMediaQuery";

interface UseFilters {
  showFilters: boolean;
  selectedFirstFilter: string | null;
  selectedLastFilter: string | null;
  handleShowFilters: (show: boolean) => void;
  handleSelectedFirstFilter: (filterType: string | null) => void;
  handleSelectedLastFilter: (filterType: string | null) => void;
}

const useFilters = (): UseFilters => {
  const isDesktop = useMediaQuery("(min-width: 1586px)");
  const [showFilters, setShowFilters] = useState(isDesktop);

  const [selectedFirstFilter, setSelectedFirstFilter] = useState<string | null>(
    null,
  );
  const [selectedLastFilter, setSelectedLastFilter] = useState<string | null>(
    null,
  );

  const handleSelectedFirstFilter = useCallback((filterType: string | null) => {
    setSelectedFirstFilter((prevFirstFilter) => {
      return filterType;
    });
  }, []);

  const handleSelectedLastFilter = useCallback((filterType: string | null) => {
    setSelectedLastFilter((prevLastFilter) => {
      return filterType;
    });
  }, []);

  const handleShowFilters = useCallback((show: boolean) => {
    setShowFilters((prevShowFilters) => {
      return show;
    });
  }, []);

  return {
    showFilters,
    selectedFirstFilter,
    selectedLastFilter,
    handleShowFilters,
    handleSelectedFirstFilter,
    handleSelectedLastFilter,
  };
};

export default useFilters;
